import { createBrowserRouter } from 'react-router-dom';
import ErrorPage from '../errorPage';
import Homepage from '../components/home';
import Root from '../common/root';
import Login from '../components/auth/login';
import Register from '../components/auth/register';
import ContactUs from '../components/contactUs';
import Membership from '../components/membership';
import Survey from '../components/survey';
import FindCar from '../components/findCar';
import FormPage from '../components/formPage';
import ProductPage from '../components/productPage';
import CompareCars from '../components/compareCars';
import ProtectedRoutes from './ProtectedRoutes';
import Generate from '../components/findCar/Generate';
import CompareSalvage from '../components/compareSalvage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <ErrorPage />,
    // loader: rootLoader,
    // action: rootAction,
    children: [
      { index: true, element: <Homepage /> },
      {
        path: '/login',
        element: <Login />,
      },
      {
        path: '/register',
        element: <Register />,
      },
      {
        path: '/contact_us',
        element: <ContactUs />,
      },
      {
        path: '/membership',
        element: <Membership />,
      },
      {
        path: '/survey',
        element: <Survey />,
      },
      {
        path: '/find_car',
        element: <ProtectedRoutes element={<FindCar />} /> ,
      },
      {
        path: '/find_salvageCar',
        element: <ProtectedRoutes element={<FindCar />} /> ,
      },
      {
        path: '/compareCars',
        element:<ProtectedRoutes element={<CompareCars />} />,
      },
      {
        path: '/compareSalvage',
        element:<ProtectedRoutes element={<CompareSalvage />} />,
      },
      {
        path: '/generatePage',
        element:<ProtectedRoutes element={<Generate />} />,
      },
      {
        path: '/form_page',
        element: <ProtectedRoutes element={<FormPage />} />,
      },
      {
        path: '/product_page/:vin',
        element:<ProtectedRoutes element={<ProductPage />} />,
      },
    ],
  },
]);

export default router;
